export default __webpack_public_path__ + "static/Rich-UI-UX-c90b3f8fa70b25673223fa50226eee72.webp";